import MainLayout from "../../MainLayout";
import GalleryHero from "./GalleryHero";

const Gallery = () => {
	return (
		<MainLayout color="black" page="photos">
			<GalleryHero />
		</MainLayout>
	);
};

export default Gallery;
